export const getGenericCache = async (fileName: string) => {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_GENERIC_CACHE_URL}/${fileName}`,
    );
    const data = await response.json();

    return data;
};


export const getGenericCacheUrl = () => {
    return process.env.NEXT_PUBLIC_GENERIC_CACHE_URL
}
